import { render, staticRenderFns } from "./InvestmentDrilldown.vue?vue&type=template&id=a4ff251e&scoped=true"
import script from "./InvestmentDrilldown.vue?vue&type=script&lang=js"
export * from "./InvestmentDrilldown.vue?vue&type=script&lang=js"
import style0 from "./InvestmentDrilldown.vue?vue&type=style&index=0&id=a4ff251e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ff251e",
  null
  
)

export default component.exports